var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenteredRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0708 12.1715L10.121 7.22176C9.73049 6.83123 9.73049 6.19807 10.121 5.80754C10.5115 5.41702 11.1447 5.41702 11.5352 5.80754L17.1921 11.4644C17.5826 11.8549 17.5826 12.4881 17.1921 12.8786L11.5352 18.5355C11.1447 18.926 10.5115 18.926 10.121 18.5355C9.73049 18.1449 9.73049 17.5118 10.121 17.1213L15.0708 12.1715Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenteredRightArrow);
export default __webpack_public_path__ + "static/media/centered_right_arrow.6d744314870bba92da71278c7247d19b.svg";
export { ForwardRef as ReactComponent };